import React, { Component } from "react";
import { Modal } from 'react-bootstrap';

class MainModal extends Component {

  constructor() {
    super();

    this.state = {
      title: '',
      content: '',
      show: false,
      closeCallback: null,
    };

    this.ref = null;
  }

  componentDidMount() {
    if (this.ref) {
      this.ref.showModal = this.showModal;
      this.ref.closeModal = this.closeModal;
    }
  }

  showModal = (title, message, closeCallback) => {
    this.setState({
      title: title,
      content: message,
      show: true,
      closeCallback: closeCallback,
    });
  }

  closeModal = () => {
    this.setState({
      title: '',
      content: '',
      show: false,
      closeCallback: null,
    });
    if (this.state.closeCallback) {
      this.state.closeCallback();
    }
  }

  render() {
    return (
      <div id={'mainModal'} ref={e => this.ref = e}>
        {(!this.state.show) ? null : (
        <Modal
            show={true}
            onHide={() => this.closeModal()}
            dialogClassName="modal-90w"
            container={document.getElementById('codai-workspace')}
          >
          <Modal.Header closeButton>
            <h3>
              {this.state.title}
            </h3>
          </Modal.Header>
          <Modal.Body>
            {this.state.content}
          </Modal.Body>
        </Modal>
        )}
      </div>
    );
  }
}

function showModal(title, message, closeCallback) {
  let mainModal = document.getElementById('mainModal');
  if (mainModal) {
    mainModal.showModal(title, message, closeCallback);
  }
}

function closeModal() {
  let mainModal = document.getElementById('mainModal');
  if (mainModal) {
    mainModal.closeModal();
  }
}

export default MainModal;

export { closeModal, showModal };
